import PageWrapper from "../../components/PageWrapper";
import { useTranslation } from "react-i18next";
import RoundedTable, {
  TABLE_CELL_TYPES,
} from "../../components/table-component/RoundedTable";
import CustomButton from "../../components/CustomButton";
import downloadIcon from "../../assets/download-icon.svg";
import PaymentStatusBadge from "./PaymentStatusBadge";
import { useNavigate, useParams } from "react-router-dom";
import axiosClient from "../../services/axiosClient";
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Loader, { LOADER_SIZES } from "../../components/Loader";
import InformationBox from "../../components/InformationBox";
import ErrorBox from "../../components/ErrorBox";
import SectionDivider from "../../components/SectionDivider";
import {
  buildInvoiceDocUrl,
  fetchFile,
  getFileType,
  sortByCustomOrder,
} from "../../utils/files";
import Modal from "../../components/Modal";
import editIcon from "../../assets/edit_icon.png";
import previewIcon from "../../assets/preview.svg";
import closeIcon from "../../assets/close_icon.png";
import saveIcon from "../../assets/save_icon.png";
import OtherDocsSection from "../../components/UploadOtherDocs";
import DocumentsGrid from "../../components/DocumentsGrid";
import { analyzeInvoiceForBank } from "../../services/bank/banksAnalyzeService";
import LoaderWithProgress from "../../components/LoaderWithProgress";
import TextDiv from "../../components/TextDiv";
import useLanguage from "../../utils/useLanguage";
import CustomInput from "../../components/CustomInput";
import { saveNotes } from "../../services/invoices/multiContainerWithoutC";
import FilesUpload from "../../components/FileUpload";

const ViewInvoicePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("general");
  const { currentDirection } = useLanguage();
  const [payments, setPayments] = useState([]);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [invoiceDocs, setInvoiceDocs] = useState([]);
  const [loadingInvoiceDocs, setLoadingInvoiceDocs] = useState(true);
  const [isGeneratingFiles, setIsGeneratingFiles] = useState(false);

  const [analyzeLoading, setAnalyzeLoading] = useState(false);
  const [analyzeError, setAnalyzeError] = useState("");

  const [showDocumentsGrid, setShowDocumentsGrid] = useState(false);

  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showAddNotes, setShowAddNotes] = useState(false);
  const [notesForBank, setNotesForBank] = useState("");

  const [invoiceData, setInvoiceData] = useState(null);
  const [allowEditDocuments, setAllowEditDocument] = useState(false);

  const handleGenerateFiles = async (payment) => {
    try {
      setIsGeneratingFiles(true);
      const token = localStorage.getItem("token");

      const data = {
        invoiceId: payment?.multiContainerInvoiceId,
        userId: parseFloat(localStorage.getItem("userId")), // // For subCompany
        companyBankId: invoiceData?.bankId,
        companyBranchId: invoiceData?.branchId,

        companyBankAccountId: invoiceData?.bankAccountId,

        // // For supplier
        supplierBankAccountId: invoiceData?.supplierBankAccountId,
        supplierBankId: invoiceData?.supplierBankId,
        supplierBranchId: invoiceData?.supplierBranchId,

        paymentPercentage:
          (Number(payment?.amount) /
            payment?.multiContainerInvoice.amountForSupplier) *
          100,

        isApplicationBank: true,
        isNew: false,
        downloadOnly: true,
        paymentId: payment?.id,
        toHongKong: invoiceData?.toHongKong,
        isTransactionService: invoiceData?.isTransactionService,
      };

      const invoiceNum =
        payment?.multiContainerInvoice?.invoiceNumber || "unknown";
      const amountForSupplier = payment?.amount || "0";
      const currency =
        payment?.multiContainerInvoice.supplier.currency || "unknown";
      const zipFileName = `${invoiceNum}-${amountForSupplier}${currency}.zip`;

      const res = await axios.post(
        `${process.env.REACT_APP_URL}/generatePermit`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        },
      );

      const blob = new Blob([res.data], { type: "application/zip" });

      // Use the filename we created above
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = zipFileName; // Set our custom filename
      document.body.appendChild(a);
      a.click(); // Trigger download
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url); // Clean up
    } catch (error) {
      console.error("Error downloading files:", error);
    } finally {
      setIsGeneratingFiles(false);
    }
  };

  const tableTitles = [
    {
      value: t("amount"),
      keepOnMobile: true,
    },
    {
      value: t("Date"),
      keepOnMobile: true,
    },
    {
      value: t("status"),
      keepOnMobile: true,
    },
    {
      value: t("Actions"),
      keepOnMobile: true,
    },
  ];

  const tableRows = payments.map((payment) => [
    {
      value: payment?.amount?.toFixed(4) + " USD",
      type: TABLE_CELL_TYPES.LINK,
      to: `/bankApplications/${id}/payments/${payment?.id}`,
      keepOnMobile: true,
    },
    {
      value: payment.date,
      type: TABLE_CELL_TYPES.DATE,
      keepOnMobile: true,
    },
    {
      value: (
        <>
          {payment.transactionNumber ? (
            <div className="o-column o-column--gap-size_500 o-column--vertical-align_center ">
              {payment.companyPaymentStatus === "REJECTED" && (
                <PaymentStatusBadge
                  status={
                    payment.companyPaymentStatus === "SENT_TO_POLICIES" &&
                    localStorage.getItem("organizationType") !== "BANK"
                      ? "PRIMARY_CHECK"
                      : payment.companyPaymentStatus
                  }
                />
              )}
              <div className="o-column o-column--gap-size_100 o-column--vertical-align_center ">
                <p className="u-center-text u-padding_0 u-margin_0">
                  {t("transferNumber") + ":"}
                </p>
                <span className="t-bold_bold royal-green">
                  {payment?.transactionNumber}
                </span>
              </div>
            </div>
          ) : (
            invoiceData && (
              <PaymentStatusBadge
                status={
                  payment.companyPaymentStatus === "SENT_TO_POLICIES" &&
                  localStorage.getItem("organizationType") !== "BANK"
                    ? "PRIMARY_CHECK"
                    : payment.companyPaymentStatus
                }
              />
            )
          )}
        </>
      ),
      type: TABLE_CELL_TYPES.ELEMENT,
      keepOnMobile: true,
    },
    {
      value: (
        <CustomButton
          variant="blank"
          icon={downloadIcon}
          iconSize={20}
          onClick={() => handleGenerateFiles(payment)}
          title={t("downloadFiles")}
          disabled={isGeneratingFiles}
          loading={isGeneratingFiles}
        />
      ),
      type: TABLE_CELL_TYPES.ELEMENT,
      keepOnMobile: true,
    },
  ]);

  // ▶ STATUS DERIVED HERE
  let invoiceStatus = "PENDING";

  if (invoiceData?.companyStatus === "NOT_STARTED") {
    invoiceStatus = "SENT";
  } else if (invoiceData?.companyStatus === "NOT_SENT") {
    invoiceStatus = "NOT_SENT";
  } else if (invoiceData?.companyStatus === "PENDING") {
    invoiceStatus = "PENDING";
  } else if (invoiceData?.companyStatus === "REJECTED") {
    invoiceStatus = "INCOMPLETE";
  } else if (invoiceData?.companyStatus === "ACCEPTED") {
    invoiceStatus = "ACCEPTED";
  }

  async function getInvoiceData() {
    try {
      setLoading(true);
      setError("");

      const response = await axiosClient.get(
        `/getMultiContainersInvoiceWithoutC/${id}`,
      );

      if (response.status === 200) {
        // In your other component it's response.data.invoice
        const { invoice, canEditDocument } = response.data;

        setInvoiceData(invoice);
        setAllowEditDocument(canEditDocument);
        setNotesForBank(invoice?.notesForBank);
      }
    } catch (error) {
      console.error("Error getting invoice data:", error);
      setError("errorGettingInvoiceData");
    } finally {
      setLoading(false);
    }
  }

  async function getInvoicePayments() {
    try {
      setLoading(true);
      setError("");

      const response = await axiosClient.get(
        `/multiCInvoicePaymentDetails/getAll/${id}`,
      );
      setPayments(response.data.invoicePayments);
    } catch (error) {
      console.error(error);
      setError("errorGettingInvoicePayments");
    } finally {
      setLoading(false);
    }
  }

  async function getInvoiceDocs() {
    try {
      setLoadingInvoiceDocs(true);
      setError("");

      const response = await axiosClient.get(
        `/multiContainerInvoiceWithoutC/invoiceMainFiles/${id}`,
      );

      if (response.status === 200) {
        // const docments = response.data?.data?.documents;
        const docments = response.data?.data?.documents.filter(
          (doc) =>
            doc.type !== "supplierCertificate" &&
            doc.type !== "articleOfAssociation",
        );
        setInvoiceDocs(docments);
      }
    } catch (error) {
      console.error(error);
      setError("errorGettingInvoicePayments");
    } finally {
      setLoadingInvoiceDocs(false);
    }
  }

  const handleAnalyzeInvoice = async () => {
    setAnalyzeLoading(true);
    setAnalyzeError("");
    try {
      // Convert PDFs to File objects
      const invoiceFile = invoiceDocs.find((doc) => doc.type === "invoice");
      const bankAppFile = invoiceDocs.find(
        (doc) => doc.type === "BaghdadTransactionRequest",
      );
      const certFile = invoiceDocs.find(
        (doc) => doc.type === "supplierCertificate",
      );
      const assocFile = invoiceDocs.find(
        (doc) => doc.type === "articleOfAssociation",
      );

      let invoiceBlob;
      if (invoiceFile) {
        invoiceBlob = await fetchFile(buildInvoiceDocUrl(invoiceFile), "pdf");
      }
      let bankAppBlob;
      if (bankAppFile) {
        bankAppBlob = await fetchFile(
          buildInvoiceDocUrl(bankAppFile),
          getFileType(bankAppFile.filePath),
        );
      }
      let certBlob;
      if (certFile) {
        certBlob = await fetchFile(buildInvoiceDocUrl(certFile), "pdf");
      }
      let assocBlob;
      if (assocFile) {
        assocBlob = await fetchFile(buildInvoiceDocUrl(assocFile), "pdf");
      }

      const formData = new FormData();
      formData.append("invoice", invoiceBlob);

      const response = await analyzeInvoiceForBank(formData);

      if (response.status === 200) {
        navigate(`/companyAnalyzeApplication`, {
          state: {
            data: {
              analyzedData: response.data || {},
              invoiceId: id,
            },
          },
        });
      }
    } catch (error) {
      console.log("error analyzing invoice", error);
      setAnalyzeError("errorAnalyzingInvoice");
    } finally {
      setAnalyzeLoading(false);
    }
  };

  const handleSaveNotes = async () => {
    try {
      await saveNotes(id, notesForBank);
      getInvoiceData();
    } catch (error) {
      console.log("error adding notes", error);
    }
  };

  const filesTitles = useMemo(
    () => ({
      invoice: t("invoice"),
      BaghdadTransactionRequest: t("financialTransferRequestForm"),
      MansurTransactionRequest: t("financialTransferRequestForm"),
    }),
    [t],
  );

  useEffect(() => {
    getInvoiceData();
    getInvoicePayments();
    getInvoiceDocs();
  }, []);

  const sortedInvoiceDocs = useMemo(() => {
    const orderedKeys = [
      "invoice",
      "BaghdadTransactionRequest",
      "MansurTransactionRequest",
    ];
    return sortByCustomOrder(invoiceDocs, orderedKeys, "type");
  }, [invoiceDocs]);

  const baseUrl = `${process.env.REACT_APP_URL}/multiContainerInvoiceWithoutC/getInvoiceFile`;

  return (
    <PageWrapper title={t("invoiceDetails")} withBackButton>
      <div className="">
        <SectionDivider title={t("senderAndReceiver")} />
        <div className="o-column o-column--gap-size_300">
          <TextDiv
            title="sender"
            value={
              currentDirection === "rtl"
                ? invoiceData?.subCompany.nameInAr
                : invoiceData?.subCompany.name
            }
            divClasses="o-column-row-switcher"
            pClasses="t-bold_semi-bold u-min-width-specific_200"
          />
          <TextDiv
            title="receiver"
            value={invoiceData?.supplier.name}
            divClasses="o-column-row-switcher"
            pClasses="t-bold_semi-bold u-min-width-specific_200"
          />
        </div>
      </div>

      <SectionDivider title={t("statusDetails")} />

      <div className="o-column o-column--gap-size_500">
        <div className="o-row o-row--vertical-align_center">
          <div className="u-min-width-specific_200">{t("status")}:</div>

          {payments?.[payments?.length - 1]?.transactionNumber ? (
            <div className="o-column o-column--gap-size_500 o-column--vertical-align_center ">
              {invoiceStatus === "INCOMPLETE" && (
                <PaymentStatusBadge status={invoiceStatus} />
              )}
              <div className="o-column o-column--gap-size_100 o-column--vertical-align_center ">
                <p className="u-center-text u-padding_0 u-margin_0">
                  {t("transferNumber") + ":"}
                </p>
                <span className="t-bold_bold royal-green">
                  {payments?.[payments?.length - 1]?.transactionNumber}
                </span>
              </div>
            </div>
          ) : (
            invoiceData && <PaymentStatusBadge status={invoiceStatus} />
          )}
        </div>

        {invoiceData?.rejectionReason && (
          <div className="o-row o-row--vertical-align_start">
            <div className="u-min-width-specific_200">
              {t("declineReason")}:
            </div>
            <span
              className="u-width_full-width"
              style={{ whiteSpace: "pre-line" }}
            >
              {invoiceData?.rejectionReason || t("noNotes")}
            </span>
          </div>
        )}
      </div>

      {/* Invoice Documents Section */}
      {showDocumentsGrid && (
        <>
          <SectionDivider title={t("invoiceDocuments")} />
          {loadingInvoiceDocs && <Loader size={LOADER_SIZES.MEDIUM} />}
          {!loadingInvoiceDocs && (
            <DocumentsGrid
              documents={sortedInvoiceDocs}
              filesTitles={filesTitles}
              baseUrl={baseUrl}
              filterType="invoice"
              showSubname={true}
            />
          )}
          {/* Other Documents Section */}
          <SectionDivider title={t("otherDocs")} />
          {loadingInvoiceDocs && <Loader size={LOADER_SIZES.MEDIUM} />}
          {!loadingInvoiceDocs && sortedInvoiceDocs?.length === 0 && (
            <InformationBox>{t("noDocuments")}</InformationBox>
          )}
          {!loadingInvoiceDocs && (
            <DocumentsGrid
              documents={sortedInvoiceDocs}
              filesTitles={filesTitles}
              baseUrl={baseUrl}
              filterType="non-invoice"
              showSubname={true}
            />
          )}
        </>
      )}

      <div className="u-width_full-width u-padding--top_400 u-padding--bottom_400">
        {!showDocumentsGrid && (
          <div className="u-margin--top_300 o-row o-row--horizontal-align_end ">
            <CustomButton
              variant="blank"
              title={
                showDocumentsGrid ? t("hideDocuments") : t("showDocuments")
              }
              onClick={() => setShowDocumentsGrid((prev) => !prev)}
              icon={previewIcon}
              iconSize={24}
              classList="u-width--min-width_230"
            />
          </div>
        )}

        <div className="u-margin--top_300 o-row o-row--horizontal-align_end ">
          <CustomButton
            variant="blank"
            title={t("editDocuments")}
            onClick={() => setShowUploadModal(true)}
            icon={editIcon}
            iconSize={18}
            disabled={!allowEditDocuments}
            classList="u-width--min-width_230"
          />
        </div>

        <div className="u-margin--top_300 o-row o-row--horizontal-align_end">
          {!showAddNotes && (
            <CustomButton
              variant="blank"
              title={t("addNotesForBank")}
              onClick={() => setShowAddNotes(true)}
              icon={editIcon}
              iconSize={15}
              classList="u-width--min-width_230"
            />
          )}
        </div>
      </div>

      {/* <div className="u-margin--top_300 o-row o-row--horizontal-align_end">
        <CustomButton
          icon={analyzeIcon}
          title={t("analyzeFiles")}
          variant="blank"
          onClick={handleAnalyzeInvoice}
          disabled={analyzeLoading}
        />
      </div> */}

      {showAddNotes ? (
        <div>
          <CustomInput
            type="textarea"
            isOpen={showAddNotes}
            onClose={() => setShowAddNotes(false)}
            title={`${t("notesForBank")}: `}
            value={notesForBank}
            onChange={(e) => setNotesForBank(e.target.value)}
          />
          <div className="o-row o-row--horizontal-align_end o-row--gap-size_200 u-margin--top_300">
            <CustomButton
              variant="blank"
              title={t("cancel")}
              onClick={() => setShowAddNotes(false)}
              icon={closeIcon}
              iconSize={13}
            />
            <CustomButton
              variant="primary"
              title={t("save")}
              onClick={() => {
                handleSaveNotes();
                setShowAddNotes(false);
              }}
              icon={saveIcon}
              iconSize={18}
            />
          </div>
        </div>
      ) : (
        invoiceData?.notesForBank && (
          <div className="u-margin--top_300">
            <div>
              <label className="t-bold_bold">{t("notesForBank")}:</label>
              <p style={{ whiteSpace: "pre-line" }}>
                {invoiceData?.notesForBank}
              </p>
            </div>
          </div>
        )
      )}

      {analyzeError && <ErrorBox>{t(analyzeError)}</ErrorBox>}
      {analyzeLoading && <LoaderWithProgress loadingText={"analyzingFiles"} />}

      {/* Payments Section */}
      <div className="u-margin--top_700">
        <SectionDivider>
          <p className="t-bold_bold t-text-large">{t("companyPayments")}</p>
        </SectionDivider>
        {loading && <Loader size={LOADER_SIZES.MEDIUM} />}
        {error && <ErrorBox>{t(error)}</ErrorBox>}
        {!loading && !error && payments.length === 0 && (
          <InformationBox>{t("noPaymentsForInvoice")}</InformationBox>
        )}
        {!loading && !error && payments.length > 0 && (
          <RoundedTable titles={tableTitles} rows={tableRows} />
        )}
      </div>
      {showUploadModal && (
        <UploadApplicationsDocumentsModal
          isOpen={showUploadModal}
          onClose={() => setShowUploadModal(false)}
          onSave={getInvoiceDocs}
          title="uploadApplicationsDocuments"
          modalSize="medium"
          invoice={{
            files: {
              invoice: invoiceDocs.find((doc) => doc?.type === "invoice"),
            },
          }}
          invoiceId={id}
        />
      )}
    </PageWrapper>
  );
};

function UploadApplicationsDocumentsModal({
  onClose,
  modalSize = "medium",
  invoiceId,
  invoice,
  onSave,
}) {
  const { t } = useTranslation("general");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updatingError, setUpdatingError] = useState("");
  const [isLoadingFiles, setIsLoadingFiles] = useState(true);
  const [files, setFiles] = useState({
    customsDeclaration: null,
    thirdPartyContract: null,
  });
  const [invoiceDocs, setInvoiceDocs] = useState([]);
  const [otherFiles, setOtherFiles] = useState([]);

  // Fetch existing files on component mount
  useEffect(() => {
    const fetchExistingFiles = async () => {
      try {
        setIsLoadingFiles(true);

        const response = await axiosClient.get(
          `/multiContainerInvoiceWithoutC/invoiceMainFiles/${invoiceId}`,
        );

        const allDocs = response.data?.data?.documents || [];
        const invoiceFiles = [];
        const fileMetadata = {};
        const otherDocsFiles = [];

        // Categorize files
        for (const file of allDocs) {
          const fileType = file.type;

          // Skip supplier certificate and article of association
          if (
            fileType === "supplierCertificate" ||
            fileType === "articleOfAssociation" ||
            fileType === "BaghdadTransactionRequest"
          ) {
            continue;
          }

          if (fileType === "invoice") {
            invoiceFiles[0] = {
              name: file.name || `${fileType}.pdf`,
              _isExisting: true,
              _id: file.id,
            };
          } else if (fileType.startsWith("invoice-")) {
            const index = parseInt(fileType.split("-")[1]);
            invoiceFiles[index] = {
              name: file.name || `${fileType}.pdf`,
              _isExisting: true,
              _id: file.id,
            };
          } else if (fileType === "customsDeclaration") {
            fileMetadata.customsDeclaration = {
              name: file.name || `${fileType}.pdf`,
              _isExisting: true,
              _id: file.id,
            };
          } else if (fileType === "thirdPartyContract") {
            fileMetadata.thirdPartyContract = {
              name: file.name || `${fileType}.pdf`,
              _isExisting: true,
              _id: file.id,
            };
          } else {
            // User-named files go to "Other Docs" section
            otherDocsFiles.push({
              id: file.id,
              value: fileType,
              file: {
                name: file.name || `${fileType}.pdf`,
                _isExisting: true,
                _id: file.id,
              },
            });
          }
        }

        // Set files metadata
        setFiles((prev) => ({
          ...prev,
          ...fileMetadata,
        }));

        // Set invoice files (filter out undefined entries)
        setInvoiceDocs(invoiceFiles.filter(Boolean));

        // Set user-named files to Other Docs section
        setOtherFiles(otherDocsFiles);
      } catch (err) {
        console.error("Error fetching existing files:", err);
      } finally {
        setIsLoadingFiles(false);
      }
    };

    if (invoiceId) {
      fetchExistingFiles();
    } else {
      setIsLoadingFiles(false);
    }
  }, [invoiceId]);

  const handleClose = () => {
    setFiles({
      customsDeclaration: null,
      thirdPartyContract: null,
    });
    setInvoiceDocs([]);
    setOtherFiles([]);
    setUpdatingError("");
    onClose();
  };

  const handleFileChange = (fieldName, file) => {
    if (file && file.type !== "application/pdf") {
      setUpdatingError("onlyPdfFilesAllowed");
      return;
    }
    setUpdatingError("");
    setFiles((prev) => ({
      ...prev,
      [fieldName]: file,
    }));
  };

  const handleDeleteFile = (fieldName) => {
    setFiles((prev) => ({
      ...prev,
      [fieldName]: null,
    }));
  };

  const handleSave = async () => {
    try {
      setIsSubmitting(true);
      setUpdatingError("");

      const formData = new FormData();

      // Track which invoice slots exist
      const allInvoiceTypes = ["invoice"];
      for (let i = 0; i < invoiceDocs.length; i++) {
        if (i > 0) allInvoiceTypes.push(`invoice-${i}`);
      }

      // Add invoices (main and additional)
      for (let i = 0; i < invoiceDocs.length; i++) {
        const invoice = invoiceDocs[i];

        if (!invoice) continue; // Skip null entries

        if (!invoice._isExisting) {
          // New file - append it
          if (i === 0) {
            formData.append("invoice", invoice);
          } else {
            formData.append(`invoice-${i}`, invoice);
          }
        } else {
          // Existing file - send empty string to keep it
          if (i === 0) {
            formData.append("invoice", "");
          } else {
            formData.append(`invoice-${i}`, "");
          }
        }
      }

      // Add customs declaration
      if (files.customsDeclaration) {
        if (!files.customsDeclaration._isExisting) {
          formData.append("customsDeclaration", files.customsDeclaration);
        } else {
          formData.append("customsDeclaration", "");
        }
      }

      // Add third party contract
      if (files.thirdPartyContract) {
        if (!files.thirdPartyContract._isExisting) {
          formData.append("thirdPartyContract", files.thirdPartyContract);
        } else {
          formData.append("thirdPartyContract", "");
        }
      }

      // Use consistent field names and store custom names as metadata to preserve UTF-8 encoding
      const otherDocMetadata = [];
      for (let i = 0; i < otherFiles.length; i++) {
        const file = otherFiles[i];
        if (file.file) {
          if (!file.file._isExisting) {
            formData.append(`otherDoc_${i}`, file.file);
          } else {
            formData.append(`otherDoc_${i}`, "");
          }
          // Store the custom name as UTF-8 metadata
          otherDocMetadata.push({
            index: i,
            name: file.value,
          });
        }
      }
      // Append metadata as JSON string for backend to parse
      if (otherDocMetadata.length > 0) {
        formData.append("otherDocNames", JSON.stringify(otherDocMetadata));
      }

      await axiosClient.put(
        `/multiContainerInvoiceWithoutC/invoiceMainFiles/${invoiceId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      onSave?.();
      handleClose();
    } catch (err) {
      console.error(err);
      setUpdatingError("errorUploadingPaymentFiles");
    } finally {
      setIsSubmitting(false);
    }
  };

  const error = updatingError;

  return (
    <Modal
      title={t("editInvoiceDocuments")}
      onClose={handleClose}
      modalSize={modalSize}
      error={t(error)}
      footer={
        <>
          {isSubmitting && <Loader size={LOADER_SIZES.MEDIUM} />}
          <section className="o-row o-row--gap-size_300 o-row--horizontal-align_end">
            <CustomButton
              title={t("cancel")}
              onClick={handleClose}
              variant="blank"
              icon={closeIcon}
              iconSize={14}
            />
            <CustomButton
              title={t("save")}
              onClick={handleSave}
              icon={saveIcon}
              iconSize={20}
              disabled={isSubmitting || isLoadingFiles}
            />
          </section>
        </>
      }
    >
      <InformationBox>
        <p>{t("uploadDocumentsForBeneficiary")}</p>
      </InformationBox>

      {error && <ErrorBox>{t(error)}</ErrorBox>}

      {isLoadingFiles ? (
        <Loader size={LOADER_SIZES.MEDIUM} />
      ) : (
        <div className="o-column o-column--gap-size_300">
          <div className="o-column o-column--gap-size_200 u-margin--bottom_500">
            {/* Invoice Section */}
            <div className="o-column u-margin--top_200">
              <SectionDivider title={t("invoice")} noMargin={true} />

              {/* Main Invoice */}
              <FilesUpload
                file={invoiceDocs[0]}
                onFileChange={(file) => {
                  if (file && file.type !== "application/pdf") {
                    setUpdatingError("onlyPdfFilesAllowed");
                    return;
                  }
                  setUpdatingError("");
                  setInvoiceDocs((prev) => {
                    const updated = [...prev];
                    updated[0] = file;
                    return updated;
                  });
                }}
                onDeleteFile={() => {
                  setInvoiceDocs((prev) => prev.filter((_, i) => i !== 0));
                }}
                label={t("invoice")}
                accept=".pdf,application/pdf"
                isMand={true}
              />

              {/* Additional Invoices */}
              {invoiceDocs.length > 1 && (
                <div className="o-column o-column--gap-size_200 u-margin--top_300">
                  <p className="t-bold_semi-bold">{t("additionalInvoices")}</p>
                  {invoiceDocs.slice(1).map((doc, index) => (
                    <FilesUpload
                      key={index + 1}
                      file={doc}
                      onFileChange={(file) => {
                        if (file && file.type !== "application/pdf") {
                          setUpdatingError("onlyPdfFilesAllowed");
                          return;
                        }
                        setUpdatingError("");
                        setInvoiceDocs((prev) => {
                          const updated = [...prev];
                          updated[index + 1] = file;
                          return updated;
                        });
                      }}
                      onDeleteFile={() => {
                        setInvoiceDocs((prev) =>
                          prev.filter((_, i) => i !== index + 1),
                        );
                      }}
                      label={`${t("invoice")} ${index + 2}`}
                      accept=".pdf,application/pdf"
                    />
                  ))}
                </div>
              )}

              {/* Add Another Invoice Button */}
              <div className="u-margin--top_300">
                <CustomButton
                  title={t("addAnotherInvoice")}
                  variant="blank"
                  onClick={() => {
                    setInvoiceDocs((prev) => [...prev, null]);
                  }}
                  icon="addP"
                  iconSize={20}
                />
              </div>
            </div>

            {/* Customs Declaration Section */}
            <div className="o-column u-margin--top_200">
              <SectionDivider title={t("customsDeclaration")} noMargin={true} />
              <FilesUpload
                file={files.customsDeclaration}
                onFileChange={(file) =>
                  handleFileChange("customsDeclaration", file)
                }
                onDeleteFile={() => handleDeleteFile("customsDeclaration")}
                label={t("customsDeclaration")}
                accept=".pdf,application/pdf"
              />
            </div>

            {/* Third Party Contract Section */}
            <div className="o-column u-margin--top_200">
              <SectionDivider title={t("thirdPartyContract")} noMargin={true} />
              <FilesUpload
                file={files.thirdPartyContract}
                onFileChange={(file) =>
                  handleFileChange("thirdPartyContract", file)
                }
                onDeleteFile={() => handleDeleteFile("thirdPartyContract")}
                label={t("thirdPartyContract")}
                accept=".pdf,application/pdf"
              />
            </div>

            <OtherDocsSection
              otherFiles={otherFiles}
              setOtherFiles={setOtherFiles}
            />
          </div>
        </div>
      )}
    </Modal>
  );
}

export default ViewInvoicePage;
